import fileUploadController from './file-upload.controller';
export var fileService = {
    fileUploadController: fileUploadController
};
